<div class="view-container">
  <mat-card>
    <mat-card-content>
      <div class="container" fxLayout="row" fxLayoutAlign="start center">
        
        <div class="save-info" fxFlex="20" fxLayout="column" fxLayoutAlign="start start" >
          <div>
            Autosave: On
          </div>
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <div *ngIf="debouncingSave">Changes Found</div>
            <div *ngIf="saving">Saving</div>
            <div *ngIf="!debouncingSave && !loading">Theme Saved <span *ngIf="lastSave" [matTooltip]="lastSave?.toString()" style="font-size: 0.65rem;">({{ timeAgoString(lastSave) }})</span></div>
            <mat-spinner *ngIf="saving" [diameter]="14"></mat-spinner>
          </div>
        </div>

        <div fxFlex="60" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">

          <mat-form-field class="accent">
            <mat-label>Filter Line Items</mat-label>
            <input matInput type="text" name="themeLineItemFilterTerm"
                [(ngModel)]="themeLineItemFilterTerm"
                (ngModelChange)="filterThemeLineItems()">
            <button mat-button *ngIf="themeLineItemFilterTerm" matSuffix mat-icon-button aria-label="Clear" (click)="themeLineItemFilterTerm=''; filterThemeLineItems()">
                <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
      
          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" [disabled]="hasSelectedAllLineItemGroups()" (click)="selectAllLineItemGroups()" matTooltip="Select All">
              <mat-icon>select_all</mat-icon>
            </button>
            <button mat-icon-button color="accent" [disabled]="!hasSelectedLineItemGroups()" (click)="deselectAllLineItemGroups()" matTooltip="Deselect All">
              <mat-icon>deselect</mat-icon>
            </button>
          </div>

          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" [disabled]="!hasSelectedLineItemGroups()" (click)="deleteSelectedLineItemGroups()" matTooltip="Delete Selected">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
      
          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" [disabled]="!hasSelectedLineItemGroups()" (click)="copyLineItemGroups()" matTooltip="Copy Selected">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-icon-button color="accent" (click)="pasteLineItemGroups()" matTooltip="Paste">
              <mat-icon>content_paste</mat-icon>
            </button>
          </div>
        </div>

        <div fxFlex="20" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="30px">

          <div *ngIf="theme" fxLayout="column" fxLayoutAlign="space-between center">
            <button class="m-t-15" mat-flat-button color="primary" (click)="publishTheme()">
              Publish Theme
            </button>

            <div [matTooltip]="theme.dateLastPublished" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="5px">
              <small class="text-muted">Last Published </small>
              <small>{{ timeAgoString(theme!.dateLastPublished) }}</small>
            </div>
          </div>
          
        </div>

      </div>
    </mat-card-content>
  </mat-card>  
  <mat-card *ngIf="loading">
    <mat-card-content>
      Loading...
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="!loading">
    <mat-card-content class="custom-mat-card-expansion" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="w-100" fxLayout="row">
        <mat-card class="contrast card-link banner-incomplete w-100 m-5 m-l-0" (click)="addProduct(undefined, undefined, true)">
          <mat-card-content class="h-100" fxLayout="row" fxLayoutAlign="space-between center">
            <span>Add a product</span>
          </mat-card-content>
        </mat-card>
        
        <mat-card class="contrast card-link banner-incomplete w-100 m-5" (click)="addTag()">
          <mat-card-content class="h-100" fxLayout="row" fxLayoutAlign="space-between center">
            <span>Add a tag</span>
            
            <button mat-flat-button (click)="showAutoFillTagOptions = !showAutoFillTagOptions; $event.stopPropagation();">
              Auto Fill Tags
            </button>
          </mat-card-content>
        </mat-card>
      </div>

      <div *ngIf="showAutoFillTagOptions" class="w-100 m-10 m-t-0">
        Auto Fill Tag Options:
        <form [formGroup]="autoFillTagSearchForm" (ngSubmit)="autoFillTags()" fxLayout="column"fxLayoutAlign="start start" fxLayoutGap="10px">
          
          <div fxLayout="column">
            <div fxLayout="row" fxLayoutGap="10px">
              <mat-checkbox formControlName="filterByHomesInRelease" matTooltip="Only return IFC tags from homes that are used in the same releases as the selected theme.">
                Filter IFC tags by release
              </mat-checkbox>
              <mat-checkbox formControlName="filterActiveReleases" matTooltip="Only return tags for releases that are currently active.">
                Filter active releases only
              </mat-checkbox>
              <mat-checkbox formControlName="filterByLatestIfcFiles" matTooltip="Only return tags for the latest version of IFC files.">
                Filter by latest IFC files only
              </mat-checkbox>
            </div>
            <mat-checkbox formControlName="useIfcTags" matTooltip="Return tags from IFC files instead of builder specified tags.">
              Fill IFC tags instead of builder specified tags
            </mat-checkbox>
            <mat-checkbox formControlName="ifcTagsOnly" matTooltip="Only return tags that come from IFC files.">
              Fill IFC tags only
            </mat-checkbox>
            <mat-checkbox formControlName="standardTagsOnly" matTooltip="Only return standard tags (not tags from IFC files).">
              Fill standard tags only
            </mat-checkbox>
          </div>

          <small>Filter by Tag Types</small>
          <mat-form-field class="accent">
            <mat-select formControlName="includeTagGroups" multiple>
              <mat-option *ngFor="let tagGroups of getThemeReplacementTagGroups()" [value]="tagGroups">{{ tagGroups }}</mat-option>
            </mat-select>
          </mat-form-field>

          <small>Filter by Areas</small>
          <mat-chip-list>
            <mat-chip *ngFor="let area of (areaGroups | keyvalue)" selectable="true" (click)="toggleArea(area.value)">
              {{ area.key }}
            </mat-chip>
          </mat-chip-list>

          <small>Filter by Product Types</small>          
          <mat-form-field class="w-100">
            <mat-chip-list #chipList aria-label="Selected Product Types">
              <mat-chip
                *ngFor="let productTypeId of autoFillTagSearchForm.value.selectedProductTypes"
                [selectable]="true"
                [removable]="true"
                (removed)="onRemoveAutoFillTagProductType(productTypeId)">
                {{ getProductType(productTypeId)?.name }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                #productTypeInput
                [matAutocomplete]="autoFillTagProductTypeAuto"
                [formControl]="autoFillTagProductTypeControl"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="[13, 188]"
                [matChipInputAddOnBlur]="false"
              />
            </mat-chip-list>
            <mat-autocomplete #autoFillTagProductTypeAuto="matAutocomplete" (optionSelected)="onAutoFillTagProductTypeSelected($event.option.value)">
              <mat-option *ngFor="let productType of filteredAutoFillTagProductTypes | async" [value]="productType.id">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                  <div class="product-type-dropdown-indicator" [style.background-color]="productType?.color" matTooltip="Product Type"></div>
                  <span [innerHtml]="productType.name | highlight: autoFillTagProductTypeControl.key"></span>
                </div>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          
          <div class="mt-2 w-100" fxLayout="row" fxLayoutAlign="space-between center">
            <button mat-raised-button color="primary" type="submit">Fill Tags</button>

            <button mat-raised-button mat-flat-button (click)="highlightObsoleteTags()">Highlight Obsolete Tags</button>
          </div>
        </form>
      </div>

      <div class="w-100" *ngFor="let group of filteredGroupedLineItems; let i = index">
        <mat-expansion-panel [(expanded)]="group.isExpanded" [ngClass]="{'group-border': group.isSelected}" hideToggle>
          <mat-expansion-panel-header>
            <div class="w-100 faux-card">
              <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-sm="column" fxLayoutGap="10px">
                <div fxFlex="50" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <div class="thumbnail-container">
                    <ng-container *ngIf="getProductPreview(group)" >
                      <img src="/assets/images/add-image-icon.svg" lazyLoad="{{SituViewUrl}}/home/getimage?artifactid={{getProductPreview(group)}}&filename=thumbnail.webp" class="thumbnail">
                      <mat-icon class="view-3d-button link" (click)="onView3dPreview(getProductPreview(group)); $event.stopPropagation();" color="accent">view_in_ar</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="!getProductPreview(group)">
                      <img src="/assets/images/add-image-icon.svg" class="thumbnail">
                    </ng-container>
                  </div>

                  <div fxLayout="column" fxLayoutAlign="space-between start" >
                    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="line-item-details">
                      <small *ngIf="getLineItemTypeName(group.lineItemTypeId)" class="text-info" [innerHTML]="getLineItemTypeName(group.lineItemTypeId) | highlight: themeLineItemFilterTerm"></small>
                      <small *ngIf="!getLineItemTypeName(group.lineItemTypeId)" class="text-info"><i>No product type selected</i></small>
                      <mat-icon *ngIf="group.isExpanded && group.lineItems.length > 0" (click)="duplicateLineItemTypeGroup(group); $event.stopPropagation();" matTooltip="Duplicate Group">control_point_duplicate</mat-icon>
                      <mat-icon *ngIf="allowAlternativeLineItemTypesForGroup(group)" (click)="group.showLineItemTypeSwap = true; $event.stopPropagation();" matTooltip="Swap Type">swap_horiz</mat-icon>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="line-item-details">
                      <ng-container *ngIf="getProductName(group)" >
                        <img class="company-logo" *ngIf="getCompanyLogoByProduct(group)" [src]="getCompanyLogoByProduct(group)">
                        <small *ngIf="!getCompanyLogoByProduct(group)">{{ getCompanyNameByProduct(group) }}</small>
                        <span [innerHTML]="getProductName(group) | highlight: themeLineItemFilterTerm"></span>
                        <small *ngIf="getProductSku(group)">{{ getProductSku(group) }}</small>
                      </ng-container>
                      <ng-container *ngIf="!getProductName(group)" >
                        <i>No product selected</i>
                        <mat-icon *ngIf="!getLineItemType(group.lineItemTypeId)" matTooltip="Add product" (click)="addProduct(group, undefined, false, undefined); $event.stopPropagation();">add</mat-icon>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div fxFlex="50" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="5px">

                  <mat-chip-list *ngIf="!group.isExpanded" fxFlex="50" fxLayoutAlign="start center" fxLayout="row">
                    <ng-container *ngFor="let tag of group.getDisplayTags(); let i = index">
                      <mat-chip class="green-chip" *ngIf="i < 3">
                        <div class="green-chip-label" fxLayoutGap="3px">
                          <small *ngIf="isBuilderIfcTag(tag)">({{getBuilderIfcSettingTag(tag)}})</small>
                          <span [innerHTML]="tag | highlight: themeLineItemFilterTerm"></span>
                        </div>
                      </mat-chip>
                      <mat-chip class="green-chip" *ngIf="i === 3">+{{ group.getDisplayTags().length - 3 }}</mat-chip>
                    </ng-container>
                  </mat-chip-list>

                  <mat-chip-list *ngIf="!group.isExpanded" fxFlex="50" fxLayoutAlign="start center" fxLayout="row">
                    <ng-container *ngFor="let scope of group.getDisplayScopes(); let j = index">
                      <mat-chip class="blue-chip" *ngIf="j < 3" [innerHTML]="scope.getName() | highlight: themeLineItemFilterTerm"></mat-chip>
                      <mat-chip class="blue-chip" *ngIf="j === 3">+{{ group.getDisplayScopes().length - 3 }}</mat-chip>
                    </ng-container>
                  </mat-chip-list>

                  <button mat-icon-button color="accent" *ngIf="group.isExpanded" (click)="removeLineItemGroup(group)">
                    <mat-icon>delete</mat-icon>
                  </button>

                </div>
              </div>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent> <!-- Lazy Load the content -->
            <div fxLayout="row" fxLayoutAlign="space-between stretch" >
              
              <div class="group-selector"  [ngClass]="{'group-selector-selected': group.isSelected}" fxLayout="column" fxLayoutAlign="start center" >
                <mat-icon *ngIf="group.isSelected" (click)="group.isSelected = false">check_box</mat-icon>
                <mat-icon *ngIf="!group.isSelected" (click)="group.isSelected = true">check_box_outline_blank</mat-icon>
              </div>

              <div class="group-details" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                
                <form *ngIf="!group.showLineItemTypeSwap" fxFlex="50" fxLayout="row wrap" fxLayoutAlign="space-between space-between">
                  <div *ngFor="let property of getLineItemTypeProperties(group.lineItemTypeId)" [fxFlex]="property.assetType === propertyTypes.TEMPLATE ? 100 : 49">

                    <small class="text-info" *ngIf="property.assetType === propertyTypes.TEMPLATE">{{ property.propertyName }}</small>
                    <div class="m-b-10 link" *ngIf="property.assetType === propertyTypes.TEMPLATE" (click)="addProduct(group, property.propertyName, false, property.templateName)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                      <input [fxHide]="true" matInput type="text" [(ngModel)]="group.lineItemProperties[property.propertyName]" name="{{property.propertyName}}">
                      <div class="thumbnail-container">
                        <ng-container *ngIf="getProductPreview(group, property.propertyName)" >
                          <img src="/assets/images/add-image-icon.svg" lazyLoad="{{SituViewUrl}}/home/getimage?artifactid={{getProductPreview(group, property.propertyName)}}&filename=thumbnail.webp" class="thumbnail">
                          <mat-icon class="view-3d-button link" (click)="onView3dPreview(getProductPreview(group, property.propertyName)); $event.stopPropagation();" color="accent">view_in_ar</mat-icon>
                        </ng-container>
                        <ng-container *ngIf="!getProductPreview(group, property.propertyName)">
                          <img src="/assets/images/add-image-icon.svg" class="thumbnail" [class.banner-info]="group.lineItemProperties[property.propertyName]" [class.banner-warning]="!group.lineItemProperties[property.propertyName]">
                        </ng-container>
                      </div>

                      <div fxLayout="column" fxLayoutAlign="space-between start" >
                        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="line-item-details">
                          <small class="text-info" [innerHTML]="getProductTypeName(group, property.propertyName) | highlight: themeLineItemFilterTerm"></small>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" class="line-item-details">
                          <img class="company-logo" *ngIf="getCompanyLogoByProduct(group, property.propertyName)" [src]="getCompanyLogoByProduct(group, property.propertyName)">
                          <small *ngIf="!getCompanyLogoByProduct(group, property.propertyName)">{{ getCompanyNameByProduct(group, property.propertyName) }}</small>
                          <span [innerHTML]="getProductName(group, property.propertyName) | highlight: themeLineItemFilterTerm"></span>
                          <small *ngIf="getProductSku(group, property.propertyName)">{{ getProductSku(group, property.propertyName) }}</small>
                          <mat-icon matTooltip="Swap product">swap_horiz</mat-icon>
                          <a *ngIf="hasProduct(group, property.propertyName)" routerLink="/products/{{ getProductId(group, property.propertyName) }}" target="_blank" (click)="$event.stopPropagation();" routerLinkActive="active">
                            <mat-icon matTooltip="Edit product">edit</mat-icon>
                          </a>
                          <mat-icon *ngIf="hasProduct(group, property.propertyName)" (click)="deleteProduct(group, property.propertyName); $event.stopPropagation();" matTooltip="Delete Product">delete</mat-icon>
                        </div>
                      </div>
                    </div>
                    
                    <mat-form-field *ngIf="!property.range && (property.assetType === propertyTypes.INT || property.assetType === propertyTypes.FLOAT || property.assetType === propertyTypes.STRING)">
                      <mat-label>{{ property.propertyName }}</mat-label>
                      <input matInput [type]="property.assetType === propertyTypes.INT || property.assetType === propertyTypes.FLOAT ? 'number' : 'text'"
                        [(ngModel)]="group.lineItemProperties[property.propertyName]"
                        (ngModelChange)="debounceSaveChanges()"
                        [required]="!property.isOptional"
                        name="{{property.propertyName}}">
                    </mat-form-field>
                    <mat-form-field *ngIf="property.range && (property.assetType === propertyTypes.INT || property.assetType === propertyTypes.FLOAT)" [required]="!property.isOptional">
                      <mat-label>{{ property.propertyName }}</mat-label>
                      <input matInput type="number"
                        [(ngModel)]="group.lineItemProperties[property.propertyName]"
                        (ngModelChange)="debounceSaveChanges()"
                        [required]="!property.isOptional"
                        name="{{property.propertyName}}"
                        [min]="getRangeMin(property.range)" [max]="getRangeMax(property.range)">
                    </mat-form-field>
                    <mat-checkbox *ngIf="property.assetType === propertyTypes.BOOL"
                      [(ngModel)]="group.lineItemProperties[property.propertyName]"
                      (ngModelChange)="debounceSaveChanges()"
                      [required]="!property.isOptional"
                      name="{{property.propertyName}}">
                      {{ property.propertyName }}
                    </mat-checkbox>
                    <mat-form-field *ngIf="property.assetType === propertyTypes.ENUM">
                      <mat-label>{{ property.propertyName }}</mat-label>
                      <mat-select [(ngModel)]="group.lineItemProperties[property.propertyName]"
                        (ngModelChange)="debounceSaveChanges()"
                        name="{{property.propertyName}}">
                        <mat-option *ngFor="let value of property.enumValues.split(',')" [value]="value">{{ value }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </form>

                <div *ngIf="group.showLineItemTypeSwap" fxFlex="50" fxLayout="row" fxLayoutGap="5px">
                  
                  <mat-form-field> 
                    <mat-label>Alternative Line Item Type</mat-label>
                    <mat-select [(ngModel)]="group.lineItemTypeId" (selectionChange)="onLineItemTypeChange(group); debounceSaveChanges();">
                      <mat-option *ngFor="let lineItemType of getAlternativeLineItemTypesForGroup(group)" [value]="lineItemType.id">
                        {{ lineItemType.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field> 

                  <button mat-icon-button *ngIf="group.isExpanded && group.showLineItemTypeSwap" (click)="group.showLineItemTypeSwap = false">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>

                <div fxFlex="50" fxLayout="row" fxLayoutGap="5px">
                  
                  <div *ngIf="!group.tagToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start center">
                    <mat-expansion-panel *ngIf="group.isExpanded" [(expanded)]="group.showTagSelection" (opened)="getTagOptions(group)" class="w-100">
                      <mat-expansion-panel-header>
                        <mat-chip-list class="w-100">
                          <mat-chip *ngFor="let tag of group.getDisplayTags()" class="green-chip" [ngClass]="{'tag-highlight': group.tagsToHighlight.has(tag)}" (click)="$event.stopPropagation();">
                            <div class="green-chip-label" fxLayoutGap="3px">
                              <small *ngIf="isBuilderIfcTag(tag)">({{getBuilderIfcSettingTag(tag)}})</small>
                              <span [innerHTML]="tag | highlight: themeLineItemFilterTerm"></span>
                            </div>
                            <button matChipRemove *ngIf="hasBuilderIfcTag(tag)" (click)="group.showTagEdit(tag)" matTooltip="Edit Tag">
                              <mat-icon style="color: #000">edit</mat-icon>
                            </button>
                            <button matChipRemove (click)="removeTagFromGroup(group, tag)" matTooltip="Remove Tag">
                              <mat-icon style="color: #000">clear</mat-icon>
                            </button>
                          </mat-chip>
                          <mat-chip *ngIf="!group.showTagSelection" class="green-chip" matTooltip="Show Unused Tags">
                            <mat-icon>add</mat-icon>
                          </mat-chip>
                          <mat-chip *ngIf="group.showTagSelection" class="green-chip" matTooltip="Hide Unused Tags">
                            <mat-icon>remove</mat-icon>
                          </mat-chip>
                        </mat-chip-list>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent> <!-- Lazy Load the content -->
                        <span *ngIf="!group.allValidTags">Loading</span>
                        <div class="chip-add-list">

                          <mat-form-field class="accent">
                            <mat-label>Filter Tags</mat-label>
                            <input matInput type="text" name="tagSearchTerm"
                                [(ngModel)]="group.tagSearchTerm"
                                (ngModelChange)="group.filterTags()">
                            <button mat-button *ngIf="group.tagSearchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="group.tagSearchTerm=''; group.filterTags()">
                                <mat-icon>close</mat-icon>
                            </button>
                          </mat-form-field>

                          <mat-chip-list class="w-100">
                              <mat-chip *ngFor="let tag of group.filteredTags" (click)="onTagSelected(group, tag)" [innerHtml]="tag.tag | highlight: group.tagSearchTerm">
                              </mat-chip> 
                          </mat-chip-list>

                          <div *ngIf="group.remainingFilteredTags.length > 0" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px" class="w-100">
                            <button mat-button (click)="group.toggleRemainingTags()">
                              <mat-icon *ngIf="!group.showRemainingTags">arrow_right</mat-icon>
                              <mat-icon *ngIf="group.showRemainingTags">arrow_drop_down</mat-icon>
                              Show All Tags
                            </button>

                            <mat-chip-list *ngIf="group.showRemainingTags" class="w-100">
                                <mat-chip *ngFor="let tag of group.remainingFilteredTags" (click)="onTagSelected(group, tag)" [innerHtml]="tag.tag | highlight: group.tagSearchTerm">
                                </mat-chip> 
                            </mat-chip-list>
                          </div>

                        </div>
                      </ng-template>
                    </mat-expansion-panel>
                  </div>

                  <div *ngIf="group.tagToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                    <mat-chip class="green-chip">
                      <div class="green-chip-label" fxLayoutGap="3px">
                        <small *ngIf="isBuilderIfcTag(group.tagToEdit)">({{getBuilderIfcSettingTag(group.tagToEdit)}})</small>
                        <span>{{ group.tagToEdit }}</span>
                      </div>
                      <button matChipRemove (click)="group.showTagEdit(); debounceSaveChanges();" matTooltip="Save Tag">
                        <mat-icon style="color: #000">save</mat-icon>
                      </button>
                      <button matChipRemove (click)="group.cancelTagEdit()" matTooltip="Remove Tag">
                        <mat-icon style="color: #000">clear</mat-icon>
                      </button>
                    </mat-chip>
                    <mat-radio-group fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="3px" >
                      <mat-radio-button *ngFor="let ifcTag of getIfcTags(group.tagToEdit)"
                        [value]="ifcTag"
                        [checked]="ifcTag == group.tagToEdit"
                        (click)="group.editTag(group.tagToEdit, ifcTag)">
                        {{ ifcTag }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div *ngIf="!group.scopeToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start center">
                    <mat-expansion-panel *ngIf="group.isExpanded" [(expanded)]="group.showScopeSelection" (opened)="group.filterScopes()" class="w-100 m-4">
                      <mat-expansion-panel-header>
                        <mat-chip-list class="w-100">
                          <ng-container *ngFor="let scope of group.getDisplayScopes(true)">
                            <mat-chip class="blue-chip" (click)="$event.stopPropagation();">
                              <span [innerHTML]="scope.getName() | highlight: themeLineItemFilterTerm"></span>
                              <button matChipRemove (click)="group.showScopeEdit(scope)" matTooltip="Edit Scopes">
                                <mat-icon style="color: #000">edit</mat-icon>
                              </button>
                              <button matChipRemove (click)="removeScopeFromGroup(group, scope.scope, scope.scopeVariant)" matTooltip="Remove Scopes">
                                <mat-icon style="color: #000">clear</mat-icon>
                              </button>
                            </mat-chip>
                          </ng-container>
                          <mat-chip *ngIf="!group.showScopeSelection" class="blue-chip" matTooltip="Show Unused Scopes">
                            <mat-icon>add</mat-icon>
                          </mat-chip>
                          <mat-chip *ngIf="group.showScopeSelection" class="blue-chip" matTooltip="Hide Unused Scopes">
                            <mat-icon>remove</mat-icon>
                          </mat-chip>
                        </mat-chip-list>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent> <!-- Lazy Load the content -->
                        <div class="chip-add-list">

                          <mat-form-field class="accent">
                            <mat-label>Filter Scopes</mat-label>
                            <input matInput type="text" name="scopeSearchTerm"
                                [(ngModel)]="group.scopeSearchTerm"
                                (ngModelChange)="group.filterScopes()">
                            <button mat-button *ngIf="group.scopeSearchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="group.scopeSearchTerm=''; group.filterScopes()">
                                <mat-icon>close</mat-icon>
                            </button>
                          </mat-form-field>

                          <mat-chip-list class="w-100">
                              <mat-chip *ngFor="let scope of group.filteredScopes" (click)="onScopeSelected(group, scope)" [innerHtml]="scopes[scope] | highlight: group.scopeSearchTerm">
                              </mat-chip>
                          </mat-chip-list>

                        </div>
                      </ng-template>
                    </mat-expansion-panel>
                  </div>

                  <div *ngIf="group.scopeToEdit" fxFlex="50" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                    <mat-chip class="blue-chip">
                      {{ group.scopeToEdit.getName() }}
                      <button matChipRemove (click)="group.showScopeEdit(); debounceSaveChanges();" matTooltip="Save Scope">
                        <mat-icon style="color: #000">save</mat-icon>
                      </button>
                    </mat-chip>
                    <mat-radio-group fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="3px" >
                      <mat-radio-button *ngFor="let scopeVariant of group.scopeToEdit.getScopeVariants()"
                        [value]="scopeVariant"
                        [checked]="scopeVariant == group.scopeToEdit.scopeVariant"
                        (click)="group.editScopeVariant(scopeVariant)">
                        {{ scopeVariants[scopeVariant] }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>

                </div>
              </div>
              
            </div>
          </ng-template>
        </mat-expansion-panel>
      </div>
    </mat-card-content>
  </mat-card>
</div>
